/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 */

// Session actions
export const INITIALIZE_SESSION_REQUEST = 'app/App/INITIALIZE_SESSION_REQUEST';
export const SESSION_INITIALIZED = 'app/App/SESSION_INITIALIZED';
export const SESSION_INITIALIZE_FAILED = 'app/App/SESSION_INITIALIZE_FAILED';
export const LOGOUT_SESSION_REQUEST = 'app/App/LOGOUT_SESSION_REQUEST';

// BOM Data actions
export const LOAD_BOM_DATA = 'app/App/LOAD_BOM_DATA';
export const BOM_DATA_LOADED = 'app/App/BOM_DATA_LOADED';
export const BOM_DATA_ERROR = 'app/App/BOM_DATA_ERROR';
export const UPDATE_BOM_DATA = 'app/App/UPDATE_BOM_DATA';
export const SUBMIT_BOM_DATA = 'app/App/SUBMIT_BOM_DATA';
export const BOM_DATA_SUBMITTED = 'app/App/BOM_DATA_SUBMITTED';
export const BOM_SUBMIT_ERROR = 'app/App/BOM_SUBMIT_ERROR';
export const CLEAR_UPLOADED_DATA = 'app/App/CLEAR_UPLOADED_DATA';

// UI state actions
export const SET_LOADING = 'app/App/SET_LOADING';
export const SET_ERROR = 'app/App/SET_ERROR';
export const CLEAR_ERROR = 'app/App/CLEAR_ERROR';
export const SET_SUCCESS = 'app/App/SET_SUCCESS';
export const CLEAR_SUCCESS = 'app/App/CLEAR_SUCCESS';
